import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { MediaModule } from '../media/media.module';
import { ImageDerivativeController } from './image-derivative.controller';
import { ImageDerivativeService } from './image-derivative.service';
import { MediaObjectSource, MediaObjectSourceService } from './media-object-source';

@Module({
  imports: [MediaModule],
  controllers: [ImageDerivativeController],
  providers: [
    ImageDerivativeService,
    PrismaService,
    // Bound by the abstract class so ImageDerivativeService injects the token
    // and stays constructible without it in specs.
    { provide: MediaObjectSource, useClass: MediaObjectSourceService },
  ],
  exports: [ImageDerivativeService],
})
export class ImagesModule {}
